<script setup>
import SpinnerView from './views/partials/SpinnerView';
import { useEPStore } from 'stores/ep';

const EPStore = useEPStore();
</script>
<template>
	<SpinnerView v-if="EPStore.spinner"/>
	<div class="container d-flex flex-column align-items-center">
		<RouterView/>
	</div>
</template>
